import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

// Components across the app
import { ClientDataPageModule } from '@app/components/client-data/client-data.component.module';
import { ModalCallMeModule } from '@components/modal-call-me/modal-call-me.module';
import { SummaryModule } from '@components/summary/summary.module';
import { QbTarificationMxModule } from '@components/tarification-mx/tarification-mx.module';
import { IonicModule } from '@ionic/angular';
import { TarificationPageRoutingModule } from './tarification-routing.module';
import { TarificationPage } from './tarification.page';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    TarificationPageRoutingModule,
    ModalCallMeModule,
    QbTarificationMxModule,
    ClientDataPageModule,
    SummaryModule,
  ],
  providers: [],
  declarations: [
    TarificationPage,
  ],
  exports: [
    TarificationPage,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TarificationPageModule { }